import { FaqItem } from 'Components/FAQ/FAQ'

const items: FaqItem[] = [
  {
    id: 'homeFaq1',
    question: 'Wait... there are two Steffen Wittigs?',
    answer: (
      <>
        <p>According to a quick Google search there are even more Steffen Wittigs!</p>
        <p>However, this page is home to the portfolios of the artist and software engineer Steffen Wittigs.</p>
      </>
    ),
  },
  {
    id: 'homeFaq2',
    question: 'This page contains two portfolios? ',
    answer: (
      <>
        <p>It is a long story...</p>
        <p>
          Basically the artist and the software engineer Steffen Wittigs had a legal battle about who the real Steffen
          Wittig is.
        </p>
        <p>
          It started when the Software Engineer Steffen Wittig somehow gained access to the Artist Steffen Wittig"s
          YouTube channel and started posting tech videos instead of cartoons.
        </p>
        <p>
          This confused many of its 9 subscribers. Then the same thing happened on the steffenwittig.com domain. The
          situation was complicated and a legal battle ensued that went on for years. Details are not known but in the
          end a judge ordered both Steffen Wittigs to share the YouTube channel and create a separate but at the same
          time combined portfolio page. Both parties consider this madness but have to deal with it.
        </p>
      </>
    ),
  },
  {
    id: 'homeFaq3',
    question: 'Who is NotSteffenWittig and is he Steffen Wittig or not?',
    answer: (
      <>
        <p>
          NotSteffenWittig is a very mysterious figure that nobody really understands. They seem to create outsider art
          but little is known about their origins and whereabouts. First traces on the web lead to a German comic
          anthology so we can assume they are German.
        </p>
        <p>
          In that case the word "Not" in NotSteffenWittig might not refer to the english word "not" but to the German
          word "Not", meaning "necessity". The exact nature of what necessitated adding Not in front of SteffenWittig is
          unclear however.
        </p>
        <p>
          Some say that "Not" is supposed to be a statement regarding artists using pseudonyms to separate their strange
          personal art from their professional persona in cases where creating art is not their full time job. The
          pseudonym is supposed to make it impossible for HR professionals to find the products of the hobby artist when
          they apply for serious roles in their main profession.
        </p>
        <p>
          In this theory NotSteffenWittig would be a pseudonym that effectively obfuscates nothing because it still
          contains the artist's whole real name (if it actually is their real name, which is still up for debate).
        </p>
        <p>
          Another, rather unlikely theory, claims that "Not X" is just a play on some social media accounts containing
          "The real X" when a name was already taken by someone less popular.
        </p>
      </>
    ),
  },
]

export default items
